import type { TelegramBotStatus } from './types';

export const normalizeStepTitle = (title: string): string => String(title || '').replace(/^\s*\d+\.\s*/, '').trim();

export const mapStatusResponse = (resStatus: Record<string, unknown> | null | undefined): TelegramBotStatus => ({
    hasToken: Boolean(resStatus?.hasToken),
    hasCustomToken: Boolean(resStatus?.hasCustomToken),
    isWebhookActive: Boolean(resStatus?.isWebhookActive),
    expectedWebhookUrl: String(resStatus?.expectedWebhookUrl || ''),
    webhookUrl: String(resStatus?.webhookUrl || ''),
    lastErrorMessage: String(resStatus?.lastErrorMessage || ''),
});
